export default {
    "loading": '加载中...',
    "language.name": "中文",
    "demo.msg": "这是语言样例",
    "product.reset": "重置",
    "product.search": "搜索",
    "login.txt001": "密码登录",
    "login.txt002": "忘记密码",
    "login.txt003": "立即登录",
    "login.txt004": "我已阅读并同意",
    "login.txt005": "隐私政策",
    "login.txt006": "关于我们",
    "login.txt007": "中智薪税技术服务有限公司",
    "login.txt008": "客服热线",
    "login.txt009": "扫一扫，联系我们",
    "login.txt010": "扫码关注公众号",
    "login.txt011": "请输入账号",
    "login.txt011-2": "请输入手机号",
    "login.txt012": "请输入密码",
    "login.txt013": "请输入验证码",
    "login.txt013-2": "请输入短信验证码",
    "login.txt014": "请同意隐私政策",
    "login.txt015": "登录成功",
    "login.txt016": "请输入账号",
    "login.txt017": "请输入密码",
    "login.txt018": "请输入验证码",
    "login.txt019": "验证码长度为4位",
    "login.txt020": "请输入短信验证码",
    "login.txt021": "请输入手机号",
    "login.txt022": "请输入正确的手机号",
    "login.txt023": "验证码发送成功",
    "login.txt024": "验证码发送失败，请稍后重试",
    "login.txt025": "获取验证码",
    "login.txt026": "短信验证码长度为6位",
    "login.txt027": "手机登录",
    "login.txt028": "",
    "login.txt029": "",
    "homepage.txt001": "角色",
    "homepage.txt002": "部门",
    "homepage.txt003": "快捷功能",
    "homepage.txt004": "政策速递",
    "homepage.txt005": "费用分布",
    "homepage.txt006": "趋势分析",
    "homepage.txt007": "年份",
    "homepage.txt008": "报销费用类型统计，单位（元）",
    "homepage.txt009": "费用",
    "homepage.txt010": "占比",
    "homepage.txt011": "报销费用月度统计，单位（元）",
    "homepage.txt012": "我的任务",
    "homepage.txt013": "关闭",
    "homepage.txt014": "更多",
    "homepage.txt015": "审批管理",
    "homepage.txt016": "将要退出系统, 是否继续？",
    "homepage.txt017": "提示",
    "homepage.txt018": "确定",
    "homepage.txt019": "取消",
    "homepage.txt020": "日期已切换为",
    "homepage.txt021": "客户已切换为",
    "homepage.txt022": "您确定要删除文件",
    "homepage.txt023": "删除成功",
    "homepage.txt024": "请求异常！",
    "homepage.txt025": "验真完成",
    "homepage.txt026": "但是存在异常信息",
    "homepage.txt027": "至少选择一条数据",
    "homepage.txt028": "操作成功",
    "homepage.txt029": "拼命加载中",
    "homepage.txt030": "是",
    "homepage.txt031": "否",
    "homepage.txt032": "操作指引",
    "homepage.txt033": "",
    "homepage.txt034": "",
    "homepage.txt035": "",
    "homepage.txt036": "",
    "homepage.txt037": "",
    "homepage.txt038": "",
    "homepage.txt039": "",
    "homepage.txt040": "",
    "homepage.shortCut001": "付款申请",
    "homepage.shortCut002": "合同申请",
    "homepage.shortCut003": "开票申请",
    "homepage.shortCut004": "出差申请",
    "homepage.shortCut005": "借款申请",
    "homepage.shortCut006": "印章申请",
    "homepage.shortCut007": "",
    "homepage.shortCut008": "",
    "homepage.shortCut009": "",
    "homepage.shortCut010": "",
    "homepage.module001": "报销申请",
    "homepage.module002": "待领导审批",
    "homepage.module003": "待财务审核",
    "homepage.module004": "已驳回",
    "homepage.module005": "草稿",
    "homepage.module006": "供应商合同",
    "homepage.module007": "待生效",
    "homepage.module008": "已撤回",
    "homepage.module009": "开票申请",
    "homepage.module010": "待审批",
    "homepage.module011": "已提交",
    "homepage.module012": "开具中",
    "homepage.module013": "差旅申请",
    "homepage.module014": "待处理",
    "homepage.module015": "借款申请",
    "homepage.module016": "印鉴申请",
    "homepage.module017": "待用印",
    "homepage.module018": "日常报销",
    "homepage.module019": "差旅报销",
    "homepage.module020": "供应商支付",
    "homepage.module021": "借款申请",
    "homepage.module022": "发票申请",
    "homepage.module023": "供应商合同",
    "homepage.module024": "客户合同",
    "homepage.module025": "差旅申请",
    "homepage.module026": "印鉴申请",
    "homepage.module027": "入出库申请",
    "homepage.module028": "出纳审核",
    "homepage.module029": "出纳支付",
    "homepage.module030": "财务复核",
    "homepage.module031": "财务开票",
    "homepage.module032": "",
    "homepage.module033": "",
    "homepage.module034": "",
    "homepage.module035": "",
    "homepage.module036": "",
    "homepage.module037": "",
    "homepage.module038": "",
    "homepage.module039": "",
    "homepage.module040": "",
    "menu.txt001": "工作台",
    "menu.cost001": "费用管控",
    "menu.cost002": "付款管理",
    "menu.cost003": "发票夹",
    "menu.cost004": "付款申请",
    "menu.cost005": "差旅申请",
    "menu.cost006": "借款管理",
    "menu.cost007": "借款申请",
    "menu.cost008": "还款申请",
    "menu.cost009": "借款/还款台账",
    "menu.cost010": "供应商管理",
    "menu.cost011": "供应商维护",
    "menu.cost012": "供应商合同管理",
    "menu.cost013": "供应商合同结束申请",
    "menu.cost014": "付款",
    "menu.cost015": "待审批申请",
    "menu.cost016": "待审批支付单",
    "menu.cost017": "其他待审批",
    "menu.cost018": "我的审批记录",
    "menu.cost019": "支付单审批记录",
    "menu.cost020": "其他审批记录",
    "menu.cost021": "财务审批",
    "menu.cost022": "财务查询",
    "menu.cost023": "出纳审核",
    "menu.cost024": "财务经理复核",
    "menu.cost025": "我的审核记录",
    "menu.cost026": "记账文件管理",
    "menu.cost027": "票据",
    "menu.cost028": "业务上传票据",
    "menu.cost029": "报销单上传票据",
    "menu.other001": "辅助功能",
    "menu.other002": "销售管理",
    "menu.other003": "对账单",
    "menu.other004": "发票申请",
    "menu.other005": "客户管理",
    "menu.other006": "客户合同管理",
    "menu.other007": "客户合同结束申请",
    "menu.other008": "工资",
    "menu.other009": "印鉴申请",
    "menu.other010": "",
    "menu.other011": "其他信息查询",
    "menu.other012": "汇率查询",
    "menu.other013": "查询明细",
    "menu.other014": "借还款查询",
    "menu.other015": "查询分类明细",
    "menu.other016": "优惠政策查询",
    "menu.other017": "",
    "menu.other018": "",
    "menu.other019": "",
    "menu.other020": "",
    "menu.inventory001": "库存管理",
    "menu.inventory002": "库存列表",
    "menu.inventory003": "出入库明细",
    "menu.inventory004": "出入库申请",
    "menu.inventory005": "出入库报表",
    "menu.report001": "报表台账",
    "menu.report002": "财务报表",
    "menu.report003": "明细报表",
    "menu.report004": "资产管理",
    "menu.report005": "费用报表",
    "menu.report006": "可视化视图",
    "menu.report007": "合同余额报表",
    "menu.report008": "税金查询",
    "menu.report009": "客户日记账",
    "menu.report010": "发票查询",
    "menu.sys001": "系统设置",
    "menu.sys002": "基础信息",
    "menu.sys003": "部门管理",
    "menu.sys004": "人员管理",
    "menu.sys005": "账户管理",
    "menu.sys006": "供应商管理",
    "menu.sys007": "项目组管理",
    "menu.sys008": "费用项目管理",
    "menu.sys009": "票据类型管理",
    "menu.sys010": "票据项目管理",
    "menu.sys011": "印鉴管理",
    "menu.sys012": "物品类型设置",
    "menu.sys013": "物品设置",
    "menu.sys014": "初始化仓库",
    "menu.sys015": "权限管理",
    "menu.sys016": "角色管理",
    "menu.sys017": "用户管理",
    "menu.sys018": "用户授权",
    "menu.sys019": "转授权",
    "menu.sys020": "预算管理",
    "menu.sys021": "流程设置",
    "menu.sys022": "报销流程设置",
    "menu.sys023": "借款流程设置",
    "menu.sys024": "差旅申请流程设置",
    "menu.sys025": "合同审批流程设置",
    "menu.sys026": "发票审批流程设置",
    "menu.sys027": "印鉴审批流程设置",
    "menu.sys028": "库存审批流程设置",
    "menu.sys029": "合同设置",
    "menu.sys030": "合同模板",
    "menu.sys031": "合同编号设置",
    "menu.sys032": "自定义设置",
    "menu.sys033": "邮件模板设置",
    "menu.sys034": "报销类型设置",
    "menu.sys035": "预算类别设置",
    "menu.sys036": "差旅地址维护",
    "menu.sys037": "报销说明项设置",
    "menu.sys038": "自定义功能开关",
    "menu.sys039": "数据初始化",
    "menu.sys040": "项目信息初始化",
    "menu.sys041": "基础档案信息初始化",
    "menu.sys042": "收款方帐户数据初始化",
    "menu.sys043": "报销指南管理",
    "menu.sys044": "日志管理",
    "menu.sys045": "",
    "menu.sys046": "",
    "menu.sys047": "",
    "menu.sys048": "",
    "menu.sys049": "",
    "index.txt001": "修改密码",
    "index.txt002": "退出登录",
    "cost.invoice001": "AI识别发票",
    "cost.invoice002": "添加其他票据",
    "cost.invoice003": "批量删除",
    "cost.invoice004": "票据号码",
    "cost.invoice005": "票据类型",
    "cost.invoice006": "票据日期",
    "cost.invoice007": "票据金额",
    "cost.invoice008": "录入日期",
    "cost.invoice009": "说明",
    "cost.invoice010": "发票状态",
    "cost.invoice011": "验真状态",
    "cost.invoice012": "验真说明",
    "cost.invoice013": "操作",
    "cost.invoice014": "查看票据",
    "cost.invoice015": "编辑/确认票据",
    "cost.invoice016": "票据验真",
    "cost.invoice017": "删除票据",
    "cost.invoice018": "待使用",
    "cost.invoice019": "待复核",
    "cost.invoice020": "已使用",
    "cost.invoice021": "票据识别结果",
    "cost.invoice022": "错误信息",
    "cost.invoice023": "异常提示",
    "cost.invoice024": "维护票据信息",
    "cost.invoice025": "票夹类型",
    "cost.invoice026": "上传票据",
    "cost.invoice027": "票据信息",
    "cost.invoice028": "费用项目",
    "cost.invoice029": "票据代码",
    "cost.invoice030": "开票日期",
    "cost.invoice031": "行程开始日期",
    "cost.invoice032": "行程结束日期",
    "cost.invoice033": "出发地址",
    "cost.invoice034": "目的地址",
    "cost.invoice035": "币种",
    "cost.invoice036": "汇率",
    "cost.invoice037": "人民币金额",
    "cost.invoice038": "含税金额",
    "cost.invoice039": "不含税金额",
    "cost.invoice040": "税额",
    "cost.invoice041": "购买方名称",
    "cost.invoice042": "购买方税号",
    "cost.invoice043": "备注",
    "cost.invoice044": "提示信息",
    "cost.invoice045": "返 回",
    "cost.invoice046": "保存并确认",
    "cost.invoice047": "票据号码",
    "cost.invoice048": "票据类型",
    "cost.invoice049": "票据文件",
    "cost.invoice050": "选择文件",
    "cost.invoice051": "请选择",
    "cost.invoice052": "请填写",
    "cost.invoice053": "请上传文件",
    "cost.invoice054": "请确认必填项信息是否已经完整录入！",
    "cost.invoice055": "未查询到附件，请联系系统运维！",
    "cost.invoice056": "票据还存在异常",
    "cost.invoice057": "是否依旧确认票据？",
    "cost.invoice058": "确认成功",
    "cost.invoice059": "是否放弃当前操作?",
    "cost.invoice060": "请先选择票据类型再上传附件!",
    "cost.invoice061": "导入文件为空，请重新选择正确的文件上传!",
    "cost.invoice062": "上传文件大小不能超过",
    "cost.invoice063": "新增国内制式发票，建议优先使用AI智能之别票据，支持一键上传、智能识别，简化录入操作！",
    "cost.invoice064": "",
    "cost.invoice065": "",
    "cost.invoice066": "",
    "cost.invoice067": "",
    "cost.invoice068": "",
    "cost.invoice069": "",
    "cost.invoice070": "",
    "cost.cost001": "填写付款单",
    "cost.cost002": "申请日期",
    "cost.cost003": "报销类型",
    "cost.cost004": "申请人",
    "cost.cost005": "收款人",
    "cost.cost006": "付款金额",
    "cost.cost007": "总金额",
    "cost.cost008": "报销原因",
    "cost.cost009": "当前环节",
    "cost.cost010": "驳回原因",
    "cost.cost011": "撤回原因",
    "cost.cost012": "是否待补充",
    "cost.cost013": "查看报销明细",
    "cost.cost014": "修改报销单",
    "cost.cost015": "删除报销单",
    "cost.cost016": "查看报销单",
    "cost.cost017": "撤回",
    "cost.cost018": "待领导审批",
    "cost.cost019": "待财务审批",
    "cost.cost020": "已驳回",
    "cost.cost021": "已撤回",
    "cost.cost022": "草稿",
    "cost.cost023": "已付款",
    "cost.cost024": "选择付款单类型",
    "cost.cost025": "无报销类型，请检查！",
    "cost.cost026": "付款单信息",
    "cost.cost027": "是否合同支付",
    "cost.cost028": "供应商",
    "cost.cost029": "合同编号",
    "cost.cost030": "开票日期",
    "cost.cost031": "报销人",
    "cost.cost032": "部门",
    "cost.cost033": "项目组",
    "cost.cost034": "收款方-个人",
    "cost.cost035": "差旅编号",
    "cost.cost036": "收款方-供应商",
    "cost.cost037": "支付方式",
    "cost.cost038": "银行账号",
    "cost.cost039": "维护银行账号",
    "cost.cost040": "查看",
    "cost.cost041": "联系方式",
    "cost.cost042": "费用信息",
    "cost.cost043": "从发票夹选择",
    "cost.cost044": "分摊",
    "cost.cost045": "上传附件",
    "cost.cost046": "删除行",
    "cost.cost047": "异常",
    "cost.cost048": "合同总额",
    "cost.cost049": "总金额不超过",
    "cost.cost050": "已支付",
    "cost.cost051": "支付在途（不含本单）",
    "cost.cost052": "支付次数（不含本单）",
    "cost.cost053": "合同余额",
    "cost.cost054": "报销合计",
    "cost.cost055": "借款信息",
    "cost.cost056": "冲借款金额",
    "cost.cost057": "付款合计",
    "cost.cost058": "取 消",
    "cost.cost059": "存草稿",
    "cost.cost060": "提 交",
    "cost.cost061": "元",
    "cost.cost062": "借款类型",
    "cost.cost063": "借款原因",
    "cost.cost064": "金额",
    "cost.cost065": "请填写报销明细后再提交报销单！",
    "cost.cost066": "报销明细中",
    "cost.cost067": "不能为空！",
    "cost.cost068": "请输入正确的联系方式！",
    "cost.cost069": "借款冲抵金额不能大于借款金额！",
    "cost.cost070": "借款冲抵金额不能大于费用总金额，请重新输入!！",
    "cost.cost071": "您确定要删除此项报销记录?",
    "cost.cost072": "上传",
    "cost.cost073": "可选择文件或微信扫码上传附件",
    "cost.cost074": "微信扫码上传",
    "cost.cost075": "选择文件",
    "cost.cost076": "点击按钮上传附件",
    "cost.cost077": "附件列表",
    "cost.cost078": "确 定",
    "cost.cost079": "取 消",
    "cost.cost080": "不支持此类型的文件",
    "cost.cost081": "未识别到票据，请先上传票据后再提交",
    "cost.cost082": "是否确认提交票据识别",
    "cost.cost083": "暂无附件",
    "cost.cost084": "分摊信息维护",
    "cost.cost085": "分摊类型",
    "cost.cost086": "提示：如同时选择了【项目组】和【分摊信息】，将以【分摊信息】填写的项目为准。",
    "cost.cost087": "方式",
    "cost.cost088": "分摊信息",
    "cost.cost089": "比例",
    "cost.cost090": "取消分摊",
    "cost.cost091": "请先设置分摊信息在进行保存！",
    "cost.cost092": "分摊金额不能为0,请重新输入！",
    "cost.cost093": "分摊总金额应为",
    "cost.cost094": "常用项目",
    "cost.cost095": "选择项目",
    "cost.cost096": "本部门项目",
    "cost.cost097": "全部项目",
    "cost.cost098": "医疗项目，请单独申报",
    "cost.cost099": "申请提交后将正式进入审批，审批流程如下",
    "cost.cost100": "当前报销没有匹配到符合条件的报销流程，不能提交",
    "cost.cost101": "预算情况",
    "cost.cost102": "选择票据",
    "cost.cost103": "添加至报销单",
    "cost.cost104": "录入时间",
    "cost.cost105": "是否确认将所选票据添加至报销单",
    "cost.cost106": "请填写原因说明",
    "cost.cost107": "报销单撤回",
    "cost.cost108": "撤回原因",
    "cost.cost109": "报销单驳回",
    "cost.cost110": "撤回原因",
    "cost.cost111": "查看流程信息",
    "cost.cost112": "完整审批流程",
    "cost.cost113": "删除附件",
    "cost.cost114": "请上传审核单附件后再提交报销单",
    "cost.cost115": "",
    "cost.cost116": "",
    "cost.cost117": "",
    "cost.cost118": "",
    "cost.cost119": "",
    "cost.cost120": "",
    "cost.cost121": "",
    "cost.cost122": "",
    "cost.cost123": "",
    "cost.cost124": "",
    "cost.cost125": "",
    "cost.cost126": "",
    "cost.cost127": "",
    "cost.cost128": "",
    "cost.cost129": "",
    "cost.cost130": "",
    "d": "d",
}
